import { OnDestroy, Injectable } from '@angular/core';
import { Dexie } from 'dexie';

import { Offer } from '../models/product';

class DbEntryOffer {
	constructor(
		readonly offer: string
	) {}
}

@Injectable({ providedIn: 'root' })
export class OfferWizardDb extends Dexie implements OnDestroy {
	private static readonly OFFER_ID = 0;
	declare private readonly offers: Dexie.Table<DbEntryOffer, number>;

	constructor() {
		super('offerWizard');
		this.version(1).stores({
			offers: ',offer'
		});

		this.offers.mapToClass(DbEntryOffer);
	}

	ngOnDestroy() {
		this.close();
	}

	async getOffer() {
		const entry = await this.offers.get(OfferWizardDb.OFFER_ID);
		if (!entry) {
			return undefined;
		}
		return <Offer> JSON.parse(entry.offer);
	}

	async removeOffer() {
		return this.offers.delete(OfferWizardDb.OFFER_ID);
	}
}
